import React, { Suspense } from 'react'

import importHandleError from '@client/utils/importHandleError'

const AsyncComponent = (opts) => (props) => {
  const [Component, setComponent] = React.useState(null)

  React.useEffect(() => {
    setComponent(importHandleError(opts?.component))
  }, [opts?.component])

  if (!Component) {
    return null
  }

  return (
    <Suspense fallback={opts?.disableLoader ? null : opts?.loading ? opts?.loading() : <div>Loading</div>}>
      <Component {...props} />
    </Suspense>
  )
}

export default AsyncComponent
